<template>
  <div class="page">
    <div
      v-for="(section, sectionIndex) in json"
      :id="section.slug"
      :key="section.slug || sectionIndex"
      :class="section.classes"
      class="section"
    >
      <div
        v-for="(content, contentIndex) in section.content"
        :key="contentIndex"
        class="block"
      >
        <RecursiveContent :content="content" />
      </div>
    </div>
  </div>
</template>

<script>
import RecursiveContent from "@/components/RecursiveContent.vue";
import { getFeatureToggles } from "@/helpers/featureToggles.js";

export default {
  name: "RecursiveTemplate",
  components: {
    RecursiveContent,
  },
  props: {
    contentPath: {
      type: String,
      required: true,
      default: "homepage/aw24",
    },
  },
  computed: {
    isHomepage() {
      const classes = Array.from(document.getElementById("app").classList);
      return classes.includes("template-index");
    },
    homepageVersion() {
      const { homepageVersion = 0 } = getFeatureToggles();
      return homepageVersion;
    },
    json() {
      try {
        if (this.homepageVersion === 1 && this.isHomepage) {
          return require(`@/content/homepage/aw24-uk-new-wardrobe-b.json`);
        }
        return require(`@/content/${this.contentPath}.json`);
      } catch (e) {
        console.error(e);
        return require(`@/content/homepage/aw24.json`);
      }
    },
  },
};
</script>
